import { ParentComponent } from 'solid-js'

type IconProps = {
  size?: number
  fill?: string
  stroke?: string
  sw?: number
  class?: string
}

const SiteIcon: ParentComponent<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    width={props.size ?? 20}
    height={props.size ?? 20}
    fill={props.fill ?? 'none'}
    stroke={props.stroke ?? 'currentColor'}
    stroke-width={props.sw ?? 2}
    stroke-linecap="round"
    stroke-linejoin="round"
    class={props.class}
  >
    {props.children}
  </svg>
)

export const IconMenu = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M3 6h18M3 12h18M3 18h18" />
  </SiteIcon>
)

export const IconBack = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M15 18l-6-6 6-6" />
  </SiteIcon>
)

export const IconClose = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M6 6l12 12M18 6L6 18" />
  </SiteIcon>
)

export const IconSearch = (p: IconProps) => (
  <SiteIcon size={p.size ?? 16} {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </SiteIcon>
)

export const IconBell = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 7 3 9H3c0-2 3-2 3-9Z" />
    <path d="M10 21a2 2 0 0 0 4 0" />
  </SiteIcon>
)

export const IconHome = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M3 9.5 12 3l9 6.5V21a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1Z" />
  </SiteIcon>
)

export const IconCompass = (p: IconProps) => (
  <SiteIcon {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="m15.5 8.5-2.6 5.4-5.4 2.6 2.6-5.4Z" />
  </SiteIcon>
)

export const IconSpark = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M12 3v3M12 18v3M5 12H2M22 12h-3M5.6 5.6 7.7 7.7M16.3 16.3l2.1 2.1M5.6 18.4 7.7 16.3M16.3 7.7l2.1-2.1" />
    <circle cx="12" cy="12" r="3" />
  </SiteIcon>
)

export const IconChat = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M21 12a8 8 0 0 1-11.5 7.2L3 21l1.8-6.5A8 8 0 1 1 21 12Z" />
  </SiteIcon>
)

export const IconUser = (p: IconProps) => (
  <SiteIcon {...p}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c1-4 5-6 8-6s7 2 8 6" />
  </SiteIcon>
)

export const IconGallery = (p: IconProps) => (
  <SiteIcon {...p}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <circle cx="9" cy="10" r="2" />
    <path d="m21 18-5-6-4 5-3-3-6 6" />
  </SiteIcon>
)

export const IconHeart = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M12 21s-7-4.5-9-9.5C1.5 7 5 4 8 5.5c1.5.7 3 2.5 4 4 1-1.5 2.5-3.3 4-4 3-1.5 6.5 1.5 5 6-2 5-9 9.5-9 9.5Z" />
  </SiteIcon>
)

export const IconStar = (p: IconProps) => (
  <SiteIcon fill="currentColor" stroke="none" {...p}>
    <path d="m12 3 2.7 5.9L21 10l-4.8 4.3L17.5 21 12 17.7 6.5 21l1.3-6.7L3 10l6.3-1.1L12 3Z" />
  </SiteIcon>
)

export const IconCoin = (p: IconProps) => (
  <SiteIcon {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v10M9 9.5a3 3 0 0 1 6 0c0 1.5-2 2-3 2-1 0-3 .5-3 2a3 3 0 0 0 6 0" />
  </SiteIcon>
)

export const IconSend = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7Z" />
  </SiteIcon>
)

export const IconPlus = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M12 5v14M5 12h14" />
  </SiteIcon>
)

export const IconDoc = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M4 4h11l5 5v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Z" />
    <path d="M15 4v5h5" />
  </SiteIcon>
)

export const IconQuestion = (p: IconProps) => (
  <SiteIcon {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M9.5 9a2.5 2.5 0 0 1 5 0c0 1.6-2.5 1.7-2.5 4M12 17h0" />
  </SiteIcon>
)

export const IconEnvelope = (p: IconProps) => (
  <SiteIcon {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 7 9-7" />
  </SiteIcon>
)

export const IconShield = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M12 2 4 5v6c0 5 3.5 8.5 8 11 4.5-2.5 8-6 8-11V5l-8-3Z" />
  </SiteIcon>
)

export const IconGrid = (p: IconProps) => (
  <SiteIcon {...p}>
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </SiteIcon>
)

export const IconTrophy = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M8 3h8v5a4 4 0 0 1-8 0V3Z" />
    <path d="M6 5H3v2a3 3 0 0 0 3 3M18 5h3v2a3 3 0 0 1-3 3M9 14h6l-1 7H10l-1-7Z" />
  </SiteIcon>
)

export const IconCard = (p: IconProps) => (
  <SiteIcon {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 10h18" />
  </SiteIcon>
)

export const IconBolt = (p: IconProps) => (
  <SiteIcon fill="currentColor" stroke="none" {...p}>
    <path d="M13 2 4 14h6l-1 8 10-13h-7l1-7Z" />
  </SiteIcon>
)

export const IconLogout = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
  </SiteIcon>
)

export const IconChevRight = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="m9 6 6 6-6 6" />
  </SiteIcon>
)

export const IconChevLeft = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="m15 6-6 6 6 6" />
  </SiteIcon>
)

export const IconArrowRight = (p: IconProps) => (
  <SiteIcon {...p}>
    <path d="M5 12h14M13 5l7 7-7 7" />
  </SiteIcon>
)

export const IconTwitter = (p: { size?: number; class?: string }) => (
  <svg viewBox="0 0 24 24" width={p.size ?? 16} height={p.size ?? 16} fill="currentColor" class={p.class}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.259 5.623L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z" />
  </svg>
)

export const IconInstagram = (p: { size?: number; class?: string }) => (
  <svg viewBox="0 0 24 24" width={p.size ?? 16} height={p.size ?? 16} fill="currentColor" class={p.class}>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
  </svg>
)

export const IconFacebook = (p: { size?: number; class?: string }) => (
  <svg viewBox="0 0 24 24" width={p.size ?? 16} height={p.size ?? 16} fill="currentColor" class={p.class}>
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
)
